import { Chip, Divider, Grid, useMediaQuery } from '@mui/material'
import { ReactElement, useContext, useEffect, useState } from 'react'
import "../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import GlobalPageHeaderText from '../../../utility/globalPageHeaderText';
import globalStyles from "../../../../assets/styles/global.module.scss";
import styles from "../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import agent from '../../../../services/api';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import IconsColor from '../../../utility/iconsColor';
import TemplateCard from '../../../global/templateCard';
import GlobalButton from '../../../utility/globalButton/button';
import { IntegrationContext, IntegrationContextPayload } from '../../../../context/integrationContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { GlobalTable } from '../../../utility/globalTable';
import deleteDoc from "../../../../assets/deleteDoc.svg";
import { formatDateTime, getBusinessUsername, getChannelIcon, getLinkedChatbotNumbers, isWhatsAppBusinessApp } from '../../../../utils/constants';
import { primaryColor } from '../../../../utils/colors';
import linkedDetailsIcon from '../../../../assets/chatbotAssets/linkedDetails.svg'
import GlobalDeletePopup from '../../../utility/globalDeletePopup/globalDeletePopup';
import whatsappIcon from '../../../../assets/Whatsapp.svg'
import highLevel from "../../../../assets/images/chatbot/integrations/gohighlevel.png";
import { metaIntegrationFaceBookDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from '../../../../models/axiosModel';
import GlobalPopUp from '../../../utility/globalPopUp';
import ScheduleMeetingPopup from './scheduleMeetingPopup';
import { GenericDataContext, GenericDataContextPayload } from '../../../../context/genericDataContext';
import { AIChatbotBreadcrumb, chatbotDetailsBreadcrumb, chatbotIntegrationsBreadcrumb, homeBreadcrumb } from '../../../../utils/breadcrumb';
import { ChatbotContext, ChatbotContextPayload } from '../../../../context/chatbotContext';
import { useGenericStore } from '../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface chatsProps {
    mainSection?: boolean
}
interface integrationRowData {
    id: number,
    iconSrc: string,
    channel_icon: any,
    channel_name: string | ReactElement,
    channel_name_label?: string,
    channel_linked_details: any,
    channel_last_updated_timestamp: string,
}
export default function IntegrationList(props: chatsProps) {
    const navigate = useNavigate()
    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)')
    const tabletScreen = useMediaQuery('(max-width : 1200px) and (min-width : 600px)')
    const innerHeight = tabletScreen ? (window.innerHeight - 130) : (window.innerHeight - 110);
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [flagDeleteIntegrationDataPopup, setFlagDeleteIntegrationDataPopup] = useState(false)
    const [integrationSelected, setIntegrationSelected] = useState<null | any>(null)
    const [integrationViewData, setIntegrationViewData] = useState<integrationRowData[] | []>([]);

    const [flagScheduleMeetingPopup, setFlagScheduleMeetingPopup] = useState<boolean>(false);
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)');

    const [integrationName, setIntegrationName] = useState<string>("");

    const { getGlobalIntegrationTypeList, getIntegrationList, integrationList, slackIntegrations, globalIntegrationTypeList, integrationListNewStructure, setSlackIntegrations, zohoIntegrations } = useContext(IntegrationContext) as IntegrationContextPayload
    const [searchParams] = useSearchParams()
    const chatbot_id = searchParams.get('chatbot_id');
    let pathname = window.location.pathname.toLowerCase();

    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload
    let integrationListStatic = [
        {
            name: "Calendly",
        },
        {
            name: "HighLevel",
        },
        {
            name: "Trello",
        },
        {
            name: "Custom API",
        },
        {
            name: "Zapier",
        },
        {
            name: "Slack",
        },
        {
            name: "Google Chat",

        },
        {
            name: "Zoho Desk"
        },
        {
            name: "GitBook"
        }
    ]
    useEffect(() => {
        (async () => {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
            await getGlobalIntegrationTypeList();
            const res = await getIntegrationList();
            if (!(res.status)) {
                handleError(res);
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        })()
    }, [])

    useEffect(() => {
        const updatedBreadcrumbs = [
            { ...homeBreadcrumb},
            AIChatbotBreadcrumb,
            { ...chatbotDetailsBreadcrumb, name: chatBotDetails?.chatbot_name ? chatBotDetails?.chatbot_name : "Chatbot", path: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}` },
            { ...chatbotIntegrationsBreadcrumb, isActive: true }
        ];
        setBreadCrumbs(updatedBreadcrumbs);
    }, [chatBotDetails])

    const deleteMetaIntegration = async (deleteIntegrationDetails: any) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        let response: any
        if (integrationSelected.channel_feature == "slack") {
            response = await agent.deleteSlackIntegration.delete(deleteIntegrationDetails.id)
        }
        else {
            let payload: any = {
                channel_id: deleteIntegrationDetails.channel_id,
                integrated_channel_id: deleteIntegrationDetails.id

            }
            if (integrationSelected.channel_feature == 'whatsapp') {
                payload.meta_integration_whatsapp_id = deleteIntegrationDetails.id
            }
            response = await agent.deleteMetaIntegration.delete(payload)
        }
        if (response && response.status) {
            let temp = [...integrationViewData]
            temp = temp.filter((integration: any) => integration.id !== deleteIntegrationDetails.id)
            setIntegrationViewData(temp)
            showSuccess("Integration Deleted Successfully!")
            navigate('/channels')
        } else {
            handleError(response);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }
    let headerList = [
        {
            name: "",
            alignment: "left",
            flagIcon: false,
            valueKey: "channel_icon",
            iconKey: "channelIcon",
            sx: { width: "20px !important", paddingRight: "0px !important" }
        },
        {
            name: "Name",
            alignment: "left",
            flagIcon: false,
            valueKey: "channel_name",
        },
        {
            name: "Purpose",
            alignment: "left",
            flagIcon: false,
            valueKey: "channel_purpose",
        },
        {
            name: "Linked Details",
            alignment: "left",
            flagIcon: true,
            valueKey: "channel_linked_details",
        },
        {
            name: "Last Modified (UTC)",
            alignment: "left",
            flagIcon: false,
            valueKey: "channel_last_updated_timestamp",
        }

    ]



    useEffect(() => {
        if (integrationListNewStructure !== null && slackIntegrations && zohoIntegrations) {
            let updatedData = integrationListNewStructure.flatMap((integrationData: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew), index: number) => {
                let channel_name = integrationData?.channel_name ? integrationData.channel_name : "whatsapp"
                const businessUsername = getBusinessUsername(integrationData, integrationData.channel_name)
                const isWaBusinessApp = isWhatsAppBusinessApp(integrationData)
                const chipLabel = isWaBusinessApp ? "WhatsApp Business App" : "WhatsApp Business Account"; 
                return {
                    id: Number(integrationData.integrated_channel_id),
                    iconSrc: linkedDetailsIcon,
                    channel_feature: integrationData.channel_name,
                    channel_icon: <Grid item sx={{ display: "flex" }}>{getChannelIcon(channel_name)}</Grid>,
                    channel_name_label: channel_name?.toLowerCase() === "whatsapp" ? `${businessUsername}(${chipLabel})` : businessUsername,
                    channel_name: channel_name?.toLowerCase() === "whatsapp" ? (
                        <Grid container alignItems="center" columnGap={1} flexWrap="nowrap">
                            <Grid item>{businessUsername}</Grid>
                            <Grid item className={`${styles.whatsAppBusinessAppLabel}`}>
                                <Chip label={chipLabel} size="small" />
                            </Grid>
                        </Grid>
                    ) : businessUsername,
                    channel_id: globalIntegrationTypeList?.find((channel: any) => channel?.channel_name.toLowerCase() == integrationData.channel_name.toLowerCase())?.channel_id || "",
                    channel_linked_details: <span style={{ color: primaryColor }}>{getLinkedChatbotNumbers(integrationData, channel_name)}</span>,
                    channel_last_updated_timestamp: formatDateTime(integrationData.created_at_timestamp, "dmyTime"),
                };
            });
            let slackIntegrationsTemp = slackIntegrations.map((slackIntegration) => {
                return {
                    id: slackIntegration.slack_integration_id,
                    iconSrc: linkedDetailsIcon,
                    channel_feature: "slack",
                    channel_name: `${slackIntegration.slack_user_real_name} - ${slackIntegration.slack_team_name}`,
                    channel_icon: <IconsColor iconName="colouredSlackIcon" height="20" width="20" />,
                    channel_linked_details: <span style={{ color: `${primaryColor} !important` }}>{`${slackIntegration.slack_channels.filter((channel) => channel.chatbot_slack_assignment_data.length > 0).length} / ${slackIntegration.slack_channels.length}`}</span>,
                    channel_last_updated_timestamp: ""
                }
            })
            let zohoIntegrationsTemp = zohoIntegrations.map((zohoIntegration) => {
                return {
                    id: zohoIntegration.zoho_integration_id,
                    iconSrc: linkedDetailsIcon,
                    channel_feature: "zoho",
                    channel_name: `${zohoIntegration.zoho_user_name} - ${zohoIntegration.zoho_user_email}`,
                    channel_icon: <IconsColor iconName="zoho" height="20" width="20" />,
                    channel_linked_details: <span style={{ color: `${primaryColor} !important` }}>{`${zohoIntegration.zoho_integration_organization_data[0].zoho_integration_organization_chatbot_data.length}`}</span>,
                    channel_last_updated_timestamp: ""
                }
            })
            setIntegrationViewData([...updatedData, ...slackIntegrationsTemp, ...zohoIntegrationsTemp])
        }
    }, [integrationListNewStructure, slackIntegrations, zohoIntegrations])
    const [adjustedHeaderList, setAdjustedHeaderList] = useState(headerList);

    const rowClicked = async (e: any, rowDetail: any) => {
        if (e.iconKey !== "editIcon") {
            navigate(`/channels/viewintegration/${rowDetail.channel_feature}?id=${rowDetail.id}`)
        }
    }

    const deleteIntegrationDataPopupOpen = (data: any) => {
        setFlagDeleteIntegrationDataPopup(true)
        setIntegrationSelected(data)
    }
    const menuItems = [
        { label: 'Delete', icon: <img src={deleteDoc} alt="delete" width={"16"} height={"16"} />, action: (e: any) => deleteIntegrationDataPopupOpen(e) },
    ];


    const getIntegrationObj = (integrationType: any) => {
        let integrationTypeName = integrationType.name.toLowerCase()
        switch (integrationTypeName) {
            case "custom api":
                return {
                    name: "Custom API",
                    image: <IconsColor iconName="customAPI" width="25px" height="25px" />,
                    description: "Add custom third-party integrations to extend your chatbot's power and meet specific needs.",
                    actionItem: <GlobalButton buttonText={"Integrate"} onClick={() => navigate(`/chatbot/viewchatbot/integration/customAPI?chatbot_id=${searchParams.get('chatbot_id')}`)} className="channelsThemeBtnStyle" />
                }
            case "highlevel":
                return {
                    name: "HighLevel",
                    image: <img alt="whatsApp" src={highLevel} height={"27"} width={"27"} />,
                    description: "Integrate with HighLevel to automate CRM tasks, nurture leads, and manage client interactions seamlessly from within your chatbot platform.",
                    actionItem: <GlobalButton buttonText={"Integrate"} className="channelsThemeBtnStyle" onClick={() => { setFlagScheduleMeetingPopup(true); setIntegrationName("HighLevel") }} />
                }
            case "calendly":
                return {
                    name: "Calendly",
                    image: <IconsColor iconName="calendly" width="25px" height="25px" />,
                    description: "Seamlessly sync with Calendly to schedule meetings effortlessly through your chatbot.",
                    actionItem: <GlobalButton buttonText={"Integrate"} className="channelsThemeBtnStyle" onClick={() => navigate(`/chatbot/viewchatbot/integration/calendly?chatbot_id=${searchParams.get('chatbot_id')}`)} />
                }
            case "trello":
                return {
                    name: "Trello",
                    image: <IconsColor iconName="trello" width="25px" height="25px" />,
                    description: "Effortlessly manage tasks and projects by integrating Trello with your chatbot. Instantly create, update, and track Trello cards directly through conversations.",
                    actionItem: <GlobalButton buttonText={"Integrate"} className="channelsThemeBtnStyle" onClick={() => { setFlagScheduleMeetingPopup(true); setIntegrationName("Trello") }} />
                }
            case "zapier":
                return {
                    name: "Zapier",
                    image: <IconsColor iconName="zapier" width="25px" height="25px" />,
                    description: "Enhance automation and streamline workflows with Zapier integration for your chatbot.",
                    actionItem: <GlobalButton buttonText={"Integrate"} className="channelsThemeBtnStyle" onClick={() => { setFlagScheduleMeetingPopup(true); setIntegrationName("Zapier") }} />
                }
            case "google chat":
                return {
                    name: "Google Chat",
                    image: <IconsColor iconName="googleChat" width="25px" height="25px" />,
                    description: "Seamlessly collaborate and communicate with teams through Google Chat integration. Automate notifications, streamline workflows, and stay connected within your chatbot.",
                    actionItem: <GlobalButton buttonText={"Integrate"} className="channelsThemeBtnStyle" onClick={() => { setFlagScheduleMeetingPopup(true); setIntegrationName("Google Chat") }} />
                }
            case "slack":
                return {
                    name: "Slack",
                    image: <IconsColor iconName="colouredSlackIcon" width="25px" height="25px" />,
                    description: "Connect Slack to receive instant updates and engage with users directly from your workspace.",
                    actionItem: <GlobalButton buttonText={"Integrate"} className="channelsThemeBtnStyle" onClick={() => navigate(`/chatbot/viewchatbot/integration/slack?chatbot_id=${searchParams.get('chatbot_id')}`)} />
                }
            case "zoho desk":
                return {
                    name: "Zoho Desk",
                    image: <IconsColor iconName="zoho" width="25px" height="25px" />,
                    description: "Enable your customer support team to retrieve information from Zoho CRM.",
                    actionItem: <GlobalButton buttonText={"Integrate"} className="channelsThemeBtnStyle" onClick={() => navigate(`/chatbot/viewchatbot/integration/zoho?chatbot_id=${searchParams.get('chatbot_id')}`)} />
                }
            case "gitbook":
                return {
                    name: "GitBook",
                    image: <IconsColor iconName="gitbook" width="25px" height="25px" />,
                    description: "Transform your GitBook into an AI Assistant, accessible across multiple messaging channels from now on.",
                    actionItem: <GlobalButton buttonText="Integrate" className="channelsThemeBtnStyle" onClick={() => { setFlagScheduleMeetingPopup(true); setIntegrationName("GitBook") }} />
                }
            default:
                return null
        }
    }

    return (
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${styles.templateWrapper}`}>
            <Grid container >
                <Grid item xs={12} sm={12}>
                    <Grid container sx={{ alignItems: "center" }} direction={"column"}>
                        {props.mainSection && <><Grid item className={globalStyles.fullwidth}>
                            <GlobalPageHeaderText
                                mainHeadText={"Channels"}
                                flagMainTextOnly
                            // mainSubText={"Create Integrations to grow your business"}
                            />
                            {!smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${styles.dividerStyle}`} sx={{ paddingTop: "16px !important" }} />}
                        </Grid>
                        </>}
                        <Grid item className={`${globalStyles.fullwidth} ${styles.lowerBlock}`} sx={{ maxHeight: `${innerHeight}px !important`, overflowY: "auto" }}>
                            <Grid container direction={"column"}>
                                {/* upper block */}
                                <Grid item sx={{ padding: "2px" }}>
                                    <Grid container direction={"column"}>
                                        <Grid item className={`${globalStyles.globalLibraryFontSize} ${globalStyles.globalHeaderFontWeight} ${globalStyles.globalHeadText} ${styles.subHeading}`}>Available Integrations</Grid>
                                        <Grid item>
                                            <Grid container>
                                                {integrationListStatic.map((integrationType: any, index: number) => {
                                                    let integration: any = getIntegrationObj(integrationType)
                                                    return <TemplateCard
                                                        key={index}
                                                        cardName={integration.name}
                                                        cardDescription={integration.description}
                                                        cardImage={integration.image}
                                                        // cardOnClick={() => { }}
                                                        cardActionItem={integration.actionItem}
                                                    />
                                                })}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* lower block */}
                                {
                                    <Grid item xs={12} sx={{ width: "100%", overflow: "scroll", boxSizing: "border-box" }}>
                                        <Grid container direction={"column"} className={styles.integrationTable}>
                                            <Grid item xs={12} className={`${globalStyles.globalLibraryFontSize} ${globalStyles.globalHeaderFontWeight} ${globalStyles.globalHeadText} ${styles.subHeading}`}>Integrated Channels</Grid>
                                            <Grid item xs={12} sx={{ paddingBottom: "25px", width: "100%" }}>
                                                <GlobalTable
                                                    headerList={adjustedHeaderList}
                                                    rowData={integrationViewData}
                                                    tableHeight={"42vh"}
                                                    tableContainerHeight={"auto"}
                                                    tableContainerMinHeight={"auto"}
                                                    onCellClick={(e: any, rowDetail: any) => { rowClicked(e, rowDetail) }}
                                                    onRowClick={(e: any) => { console.log(e) }}
                                                    deleteRowData={deleteIntegrationDataPopupOpen}
                                                    flagPagination
                                                    menuItemsFromParent={menuItems}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {flagDeleteIntegrationDataPopup &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete ${integrationSelected?.channel_name_label ?? integrationSelected.channel_name} channel`}
                    open={flagDeleteIntegrationDataPopup}
                    onClose={() => { setFlagDeleteIntegrationDataPopup(false) }}
                    onDelete={(e: any) => {
                        deleteMetaIntegration(integrationSelected)
                        setFlagDeleteIntegrationDataPopup(false)
                    }}
                />
            }
            {flagScheduleMeetingPopup &&
                <GlobalPopUp
                    open={flagScheduleMeetingPopup}
                    handleClose={() => setFlagScheduleMeetingPopup(false)}
                    flagShowCloseIcon={true}
                    titlePadding='0px'
                    paperMinWidth={flagSmallScreen ? "310px" : "700px"}
                    paperMaxwidth={flagSmallScreen ? "610px" : "750px"}
                >
                    <ScheduleMeetingPopup setFlagScheduleMeetingPopup={setFlagScheduleMeetingPopup} integrationName={integrationName} />
                </GlobalPopUp>
            }
        </Grid >

    )
}
